<div class="login-container">
  <div class="login-wrapper">
    <div
      class="login-ad"
      [attr.aria-label]="'LOGIN_PAGE.AD_AREA_LABEL' | translate"
      role="complementary"
      tabindex="-1">
      <!-- ZONA DESKTOP 1920: Revive Adserver Hosted edition iFrame Tag - Generated with Revive Adserver v5.5.0 -->
      <iframe
        class="desktop-1920"
        id="a0e46a57"
        name="a0e46a57"
        src="https://servedby.revive-adserver.net/afr.php?zoneid=18574&amp;cb=INSERT_RANDOM_NUMBER_HERE"
        frameborder="0"
        scrolling="no"
        width="722"
        height="1080"
        allow="autoplay"
        tabindex="-1"
        aria-hidden="true"
        ><a
          href="https://servedby.revive-adserver.net/ck.php?n=ac6f022a&amp;cb=INSERT_RANDOM_NUMBER_HERE"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate"
          ><img
            src="https://servedby.revive-adserver.net/avw.php?zoneid=18574&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=ac6f022a"
            border="0"
            [attr.alt]="'LOGIN_PAGE.DECORATIVE_IMAGE_ALT' | translate"
            aria-hidden="true" /></a
      ></iframe>
      <!-- ZONA DESKTOP 1440: Revive Adserver Hosted edition iFrame Tag - Generated with Revive Adserver v5.5.0 -->
      <iframe
        class="desktop-1440"
        id="a435cb13"
        name="a435cb13"
        src="https://servedby.revive-adserver.net/afr.php?zoneid=18051&cb=INSERT_RANDOM_NUMBER_HERE"
        frameborder="0"
        scrolling="no"
        width="542"
        height="746"
        allow="autoplay"
        tabindex="-1"
        aria-hidden="true"
        ><a
          href="https://servedby.revive-adserver.net/ck.php?n=afe74322&cb=INSERT_RANDOM_NUMBER_HERE"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate"
          ><img
            src="https://servedby.revive-adserver.net/avw.php?zoneid=18051&cb=INSERT_RANDOM_NUMBER_HERE&n=afe74322"
            border="0"
            [attr.alt]="'LOGIN_PAGE.DECORATIVE_IMAGE_ALT' | translate"
            aria-hidden="true" /></a
      ></iframe>
      <!-- ZONA TABLET: Revive Adserver Hosted edition Tag iFrame - Generated with Revive Adserver v5.4.1 -->
      <!-- Revive Adserver Hosted edition iFrame Tag - Generated with Revive Adserver v5.5.0 -->
      <iframe
        class="tablet"
        id="a71232bb"
        name="a71232bb"
        src="https://servedby.revive-adserver.net/afr.php?zoneid=18052&amp;cb=INSERT_RANDOM_NUMBER_HERE"
        frameborder="0"
        scrolling="no"
        width="768"
        height="1068"
        allow="autoplay"
        tabindex="-1"
        aria-hidden="true"
        ><a
          href="https://servedby.revive-adserver.net/ck.php?n=a2c36aeb&amp;cb=INSERT_RANDOM_NUMBER_HERE"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate"
          ><img
            src="https://servedby.revive-adserver.net/avw.php?zoneid=18052&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=a2c36aeb"
            border="0"
            [attr.alt]="'LOGIN_PAGE.DECORATIVE_IMAGE_ALT' | translate"
            aria-hidden="true" /></a
      ></iframe>
      <!-- ZONA MOBILE: Revive Adserver Hosted edition Tag iFrame - Generated with Revive Adserver v5.4.1 -->
      <!-- Revive Adserver Hosted edition iFrame Tag - Generated with Revive Adserver v5.5.0 -->
      <iframe
        class="mobile"
        id="ac82e588"
        name="ac82e588"
        src="https://servedby.revive-adserver.net/afr.php?zoneid=18053&amp;cb=INSERT_RANDOM_NUMBER_HERE"
        frameborder="0"
        scrolling="no"
        width="360"
        height="392"
        allow="autoplay"
        tabindex="-1"
        aria-hidden="true"
        ><a
          href="https://servedby.revive-adserver.net/ck.php?n=a8fe0ea4&amp;cb=INSERT_RANDOM_NUMBER_HERE"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate"
          ><img
            src="https://servedby.revive-adserver.net/avw.php?zoneid=18053&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=a8fe0ea4"
            border="0"
            [attr.alt]="'LOGIN_PAGE.DECORATIVE_IMAGE_ALT' | translate"
            aria-hidden="true" /></a
      ></iframe>
    </div>
    <div class="login-container" id="main-content">
      <div class="login-logo">
        <img
          src="./assets/images/MySign_Color.svg"
          altTranslate="LOGIN_PAGE.LOGO_ALT" />
      </div>
      <div class="texts-container">
        <h1 class="login-title" translate>LOGIN_PAGE.TITLE</h1>
        <div class="login-desc" translate>LOGIN_PAGE.DESC</div>

        <form (ngSubmit)="onSubmit()" class="ic1-flex-column ic1-flex" id="login-form" tabindex="-1">
          <app-submit-button
            class="login-button"
            [label]="'LOGIN_PAGE.TITLE' | translate"
            [disabled]="loading"
            translate-key="LOGIN_PAGE.TITLE"
            size="md"
            type="submit">
          </app-submit-button>
        </form>
        <div class="discover-text">
          <div translate>LOGIN_PAGE.NO_MYSIGN_DESC</div>
          <div class="activate-mysign">
            <a
              href="https://www.firma.infocert.it/?utm_id=206"
              [attr.aria-label]="
                'LOGIN_PAGE.NO_MYSIGN_ACTIVATE_ARIA' | translate
              "
              translate>
              LOGIN_PAGE.NO_MYSIGN_ACTIVATE_TEXT
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-common-modal
  modalId="auth-errors-modal"
  [title]="'LOGIN_PAGE.AUTH_ERRORS_MODAL.TITLE' | translate"
  [(visible)]="authErrorsModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleAuthErrorsModal(false)">
  <div [ngSwitch]="errorStatus">
    <div *ngSwitchCase="'DISABLED'" class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.DISABLED.TITLE
      </div>
      <div class="text" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.DISABLED.DESC
      </div>
      <ng-ui-kit-button
        (onClick)="openUrl('support')"
        color="primary"
        [label]="'LOGIN_PAGE.AUTH_ERRORS_MODAL.DISABLED.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
      <ng-ui-kit-button
        (onClick)="closeModal()"
        color="secondary"
        [label]="'COMMON.BUTTON.CLOSE' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'NO_MULTIFACTOR'" class="modal-content">
      <img src="assets/images/cert-suspended.svg" />
      <div class="title" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.NO_MULTIFACTOR.TITLE
      </div>
      <div class="text" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.NO_MULTIFACTOR.DESC
      </div>
      <ng-ui-kit-button
        (onClick)="openUrl('myInfoCert')"
        color="primary"
        [label]="
          'LOGIN_PAGE.AUTH_ERRORS_MODAL.NO_MULTIFACTOR.BUTTON' | translate
        "
        type="button"
        size="sm">
      </ng-ui-kit-button>
      <ng-ui-kit-button
        (onClick)="closeModal()"
        color="secondary"
        [label]="'COMMON.BUTTON.CLOSE' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'LOCKED'" class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.LOCKED.TITLE
      </div>
      <div class="text" translate>LOGIN_PAGE.AUTH_ERRORS_MODAL.LOCKED.DESC</div>
      <ng-ui-kit-button
        (onClick)="goToPasswordRecovery()"
        color="primary"
        [label]="'LOGIN_PAGE.AUTH_ERRORS_MODAL.LOCKED.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
      <ng-ui-kit-button
        (onClick)="closeModal()"
        color="secondary"
        [label]="'COMMON.BUTTON.CLOSE' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'TIMED_OUT'" class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.TIMED_OUT.TITLE
      </div>
      <div class="text" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.TIMED_OUT.DESC
      </div>
      <ng-ui-kit-button
        (onClick)="onSubmit()"
        color="secondary"
        [label]="'LOGIN_PAGE.AUTH_ERRORS_MODAL.TIMED_OUT.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'FAILED_AUTH_ATTEMPTS'" class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.FAILED_AUTH_ATTEMPTS.TITLE
      </div>
      <div class="text" translate>
        LOGIN_PAGE.AUTH_ERRORS_MODAL.FAILED_AUTH_ATTEMPTS.DESC
      </div>
      <ng-ui-kit-button
        (onClick)="openUrl('support')"
        color="primary"
        [label]="
          'LOGIN_PAGE.AUTH_ERRORS_MODAL.FAILED_AUTH_ATTEMPTS.BUTTON' | translate
        "
        type="button"
        size="sm">
      </ng-ui-kit-button>
      <ng-ui-kit-button
        (onClick)="closeModal()"
        color="secondary"
        [label]="'COMMON.BUTTON.CLOSE' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>
  </div>
</app-common-modal>
